function resolveAssetSource(source){
return(typeof source==='object'?source.uri:source)||null;}


module.exports=resolveAssetSource;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-native-web/dist/components/Image/resolveAssetSource.js
 ** module id = 509
 ** module chunks = 0
 **/